/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ChartPhrases {
  "use strict";

  export class ChartPhrasesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
    
    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService,
      protected webComponentMountHooks: any,
      protected $scope: angular.IScope) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

      this.baseEndpoint = appSettings.API_ENDPOINTS.chartPhrases;
      this.sectionTemplatePath = "app/plugins/chartPhrases/sectionViews/";

      this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_CHARTSPHRASES_TAB_MAIN);
      this.entityType = "ChartPhrase";
      this.initializeSections();
    };

    initializeSections(): void {
      if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_CHARTSPHRASES_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
        this.sections.push(new MainSection(0, "SECTION_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.chartPhrases,
            "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ChartPhrasesMain, null,
            this.securityKeys.MANAGEMENT_CHARTSPHRASES_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ, this.webComponentMountHooks, this.$scope, this));
      }
    }

    initializeHeader(model: any): void {
      this.headerContent = model.displayName;
      this.businessTypeDetail = model.businessTypeDetail;
    }
  }
}
